

const succes_url = 'https://img.alicdn.com/imgextra/i3/O1CN01DaK2tn1e4h3yW6vuq_!!6000000003818-0-tps-598-1280.jpg';

export const commonList = [
    'https://img.alicdn.com/imgextra/i2/O1CN01Lh53P723LyOnyUi6O_!!6000000007240-0-tps-1242-2688.jpg',
    'https://img.alicdn.com/imgextra/i2/O1CN01r88tAQ1qOdhJEDEGK_!!6000000005486-0-tps-592-1280.jpg',
    'https://img.alicdn.com/imgextra/i1/O1CN01PKeNS81V6DqGpHgTG_!!6000000002603-0-tps-592-1280.jpg',
    'https://img.alicdn.com/imgextra/i2/O1CN01DqaaUI1fL0mzqUETY_!!6000000003989-0-tps-592-1280.jpg',
    'https://img.alicdn.com/imgextra/i3/O1CN01IpQicf1qxuCHPjZQV_!!6000000005563-0-tps-592-1280.jpg'
];



export const tiyanList = ['https://img.alicdn.com/imgextra/i2/O1CN016IuRfp1iAQTyPDOXv_!!6000000004372-2-tps-776-1688.png'].concat(
    commonList.concat([
     'https://img.alicdn.com/imgextra/i3/O1CN01LKtBjR1EBOqn834Dq_!!6000000000313-2-tps-1242-2688.png',
    `${succes_url}`
   ])
);

export const yaoqingList = ['https://img.alicdn.com/imgextra/i1/O1CN01BNJ0xn1NrNhMmL6kV_!!6000000001623-2-tps-792-1656.png'].concat(
    commonList.concat([
    'https://img.alicdn.com/imgextra/i4/O1CN01sBuo5T1Sjf6LNLeHL_!!6000000002283-0-tps-592-1280.jpg',
    'https://img.alicdn.com/imgextra/i2/O1CN01DTdPBD1dBH8fRB0mw_!!6000000003697-0-tps-592-1280.jpg',
    `${succes_url}`
   ])
   );

export const fufeiList = ['https://img.alicdn.com/imgextra/i2/O1CN016IuRfp1iAQTyPDOXv_!!6000000004372-2-tps-776-1688.png'].concat(
    commonList.concat([
        'https://img.alicdn.com/imgextra/i1/O1CN011NIJsQ1zuXpfsR9d2_!!6000000006774-2-tps-1242-2688.png',
        `${succes_url}`
    ])
)

export const hezuoList = ['https://img.alicdn.com/imgextra/i2/O1CN016IuRfp1iAQTyPDOXv_!!6000000004372-2-tps-776-1688.png'].concat(
    commonList.concat([
        'https://img.alicdn.com/imgextra/i2/O1CN016BUr0Q1OIrSkRZdot_!!6000000001683-2-tps-1242-2688.png',
        `${succes_url}`
    ])
)

export const imagelist = {
    'PUMP-USDT-SWAP': {
        'img': 'https://static.coinall.ltd/cdn/oksupport/asset/currency/icon/pump.png',
        'alias': 'PUMP'
    },
    'XPL-USDT-SWAP': {
        'img': 'https://static.coinall.ltd/cdn/oksupport/asset/currency/icon/xpl.png',
        'alias': 'XPL'
    },
    'OP-USDT-SWAP': {
        'img': 'https://static.coinall.ltd/cdn/oksupport/asset/currency/icon/op.png',
        'alias': 'OP'
    },
    'ASTER-USDT-SWAP': {
        'img': 'https://static.coinall.ltd/cdn/oksupport/asset/currency/icon/aster.png',
        'alias': 'ASTER'
    },
   'BNB-USDT-SWAP': {
        'img': 'https://static.coinall.ltd/cdn/oksupport/asset/currency/icon/bnb.png',
        'alias': 'BNB'
    },
    'LINEA-USDT-SWAP': {
        'img': 'https://static.coinall.ltd/cdn/oksupport/asset/currency/icon/linea.png',
        'alias': 'LINEA'
    },
    'ORDI-USDT-SWAP': {
        'img': 'https://static.coinall.ltd/cdn/oksupport/asset/currency/icon/ordi.png',
        'alias': 'ORDI'
    },
   'OKB-USDT-SWAP': {
        'img': 'https://static.coinall.ltd/cdn/oksupport/asset/currency/icon/okb.png',
        'alias': 'OKB'
    },
   'SUI-USDT-SWAP': {
        'img': 'https://static.coinall.ltd/cdn/oksupport/asset/currency/icon/sui.png',
        'alias': 'SUI'
    },
   'APT-USDT-SWAP': {
        'img': 'https://static.coinall.ltd/cdn/oksupport/asset/currency/icon/apt.png',
        'alias': 'APT'
    },
    'TRUMP-USDT-SWAP': {
        'img': 'https://static.coinall.ltd/cdn/oksupport/asset/currency/icon/trump.png',
        'alias': 'TRUMP'
    },
    'DYDX-USDT-SWAP': {
        'img': 'https://static.coinall.ltd/cdn/oksupport/asset/currency/icon/dydx.png',
        'alias': 'Dydx'
    },
    'BTC-USDT-SWAP': {
      'img': 'https://static.coinall.ltd/cdn/oksupport/asset/currency/icon/btc.png',
      'alias': 'Bitcoin'
    },
    'PEOPLE-USDT-SWAP': {
      'img': 'https://static.coinall.ltd/cdn/oksupport/asset/currency/icon/people.png',
      'alias': 'ConstitutionDAO'
    },
    'ETH-USDT-SWAP': {
      'img': 'https://static.coinall.ltd/cdn/oksupport/asset/currency/icon/eth.png',
      'alias': 'Ethereum'
    },
    'XRP-USDT-SWAP': {
      'img': 'https://static.coinall.ltd/cdn/oksupport/asset/currency/icon/xrp.png',
      'alias': 'XRP'
    },
    'DOGE-USDT-SWAP': {
      'img': 'https://static.coinall.ltd/cdn/oksupport/asset/currency/icon/doge.png',
      'alias': 'Dogecoin'
    },
    'ADA-USDT-SWAP': {
      'img': 'https://static.coinall.ltd/cdn/oksupport/asset/currency/icon/ada.png',
      'alias': 'Cardano'
    },
    'SOL-USDT-SWAP': {
      'img': 'https://static.coinall.ltd/cdn/oksupport/asset/currency/icon/sol.png',
      'alias': 'Solana'
    },
    'DOT-USDT-SWAP': {
      'img': 'https://static.coinall.ltd/cdn/oksupport/asset/currency/icon/dot.png',
      'alias': 'Polkadot'
    },
    'UNI-USDT-SWAP': {
      'img': 'https://static.coinall.ltd/cdn/oksupport/asset/currency/icon/uni.png',
      'alias': 'Uniswap'
    },
    'AVAX-USDT-SWAP': {
      'img': 'https://static.coinall.ltd/cdn/oksupport/asset/currency/icon/avax.png',
      'alias': 'Avalanche'
    },
    'ETC-USDT-SWAP': {
      'img': 'https://static.coinall.ltd/cdn/oksupport/asset/currency/icon/etc.png',
      'alias': '以太经典'
    },
    'ATOM-USDT-SWAP': {
      'img': 'https://static.coinall.ltd/cdn/oksupport/asset/currency/icon/atom.png',
      'alias': '阿童木'
    },
    'NEAR-USDT-SWAP': {
      'img': 'https://static.coinall.ltd/cdn/oksupport/asset/currency/icon/near.png',
      'alias': 'Near Protocol'
    },
    'SAND-USDT-SWAP': {
      'img': 'https://static.coinall.ltd/cdn/oksupport/asset/currency/icon/sand.png',
      'alias': 'Sandbox'
    },
    'MANA-USDT-SWAP': {
      'img': 'https://static.coinall.ltd/cdn/oksupport/asset/currency/icon/mana.png',
      'alias': 'Decentraland'
    },
    'APE-USDT-SWAP': {
      'img': 'https://static.coinall.ltd/cdn/oksupport/asset/currency/icon/ape.png',
      'alias': 'ApeCoin'
    },
    'PEPE-USDT-SWAP': {
      'img': 'https://static.coinall.ltd/cdn/oksupport/asset/currency/icon/pepe.png',
      'alias': 'Pepe'
    },
    'GMT-USDT-SWAP': {
      'img': 'https://static.coinall.ltd/cdn/oksupport/asset/currency/icon/gmt.png',
      'alias': 'STEPN'
    },
    'AXS-USDT-SWAP': {
      'img': 'https://static.coinall.ltd/cdn/oksupport/asset/currency/icon/axs.png',
      'alias': 'Axie Infinity'
    }
  };
